import StarIcon from '@/components/ui/icons/star';
import CurrencyIcon from '@/components/ui/icons/currency-icon';
const RabehRedeem = ({ t }) => {
  return (
    <div className='flex flex-col items-center justify-center py-7'>
      <StarIcon />
      <p className='mt-2 mb-4.25 text-xl font-bold max-sm:text-sm lg:mb-6.75'>
        {t('Congratulations')}
      </p>
      <div className='text-center capitalize max-sm:text-xs'>
        <p className='leading-8'>
          {t.rich('points_earned', {
            points: (chunks) => <span className='font-bold'>{chunks}</span>,
            value: 100,
          })}
        </p>
        <p className='flex items-center justify-center gap-1'>
          {t.rich('redeem_for', {
            discount: (chunks) => (
              <span className={`flex items-center gap-1 font-bold`}>
                {chunks}
                <CurrencyIcon className='size-3.5' />
              </span>
            ),
            value: '1',
          })}
        </p>
      </div>
    </div>
  );
};

export default RabehRedeem;
